function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  strokeWidth: 1.35,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M4 6H21.5"
}), React.createElement("path", {
  d: "M4 13H21.5"
}), React.createElement("path", {
  d: "M4 20H21.5"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    className: "icon",
    style: {
      "width": "1em",
      "height": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/hamburger.a7a05d5c.svg";
export { SvgComponent as ReactComponent };